import { settingsSubsistenceRateConstants } from './constants';


const initialState = {
  loading: false,
  data: {},
  recordToEdit: null,
  isEditorActive: false,
}

export function settingsSubsistenceRate(state = initialState, action) {
  switch (action.type) {
    case settingsSubsistenceRateConstants.GET_SETTINGS_SUBSISTENCE_REQUEST_DATA:
      return {
        ...state,
        loading: false,
        details: action.payload,
      };
    case settingsSubsistenceRateConstants.GET_SETTINGS_SUBSISTENCE_RATE_REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
      };
    case settingsSubsistenceRateConstants.GET_SETTINGS_SUBSISTENCE_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case settingsSubsistenceRateConstants.GET_SETTINGS_SUBSISTENCE_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: {},
      };
    case settingsSubsistenceRateConstants.GET_SETTINGS_SUBSISTENCE_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: {},
      };
    case settingsSubsistenceRateConstants.SUBSISTENCE_RATE_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: [...state.data, action.payload]
      };
    case settingsSubsistenceRateConstants.SUBSISTENCE_RATE_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: state.data.map(record => action.payload.id === record.id ? action.payload : record)
      };
    case settingsSubsistenceRateConstants.SUBSISTENCE_RATE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: state.data.filter(record=>record.id !== action.payload)
      };
    case settingsSubsistenceRateConstants.TOGGLE_EDITOR:
      return {
        ...state,
        isEditorActive: !state.isEditorActive,
        recordToEdit: action.payload
      };
    default:
      return state
  }
}
